module.exports = __webpack_public_path__ + "static/media/Nymphadora Tonks 3.9244ff39.jpg";